module.exports = __webpack_public_path__ + "img/agronomy1.9f6ff931.png";